import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";

export interface IIsiDtoGLOBXXXOpenArgs extends IIsiDataTransferObject  {
    actionContextId?: string;
    associatedviewContextId?: string;
}
export class IsiDtoGLOBXXXOpenArgs extends IsiDataTransferObject implements IIsiDtoGLOBXXXOpenArgs {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGLOBXXXOpenArgs, Isilog.IsiComponent.IsiDataTransferObject";
    actionContextId?: string;
    associatedviewContextId?: string;

    constructor(data?: IIsiDtoGLOBXXXOpenArgs) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.actionContextId = _data["actionContextId"] !== undefined ? _data["actionContextId"] : <any>null;
            this.associatedviewContextId = _data["associatedviewContextId"] !== undefined ? _data["associatedviewContextId"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGLOBXXXOpenArgs): IsiDtoGLOBXXXOpenArgs {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGLOBXXXOpenArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["actionContextId"] = this.actionContextId !== undefined ? this.actionContextId : <any>null;
        data["associatedviewContextId"] = this.associatedviewContextId !== undefined ? this.associatedviewContextId : <any>null;
        return data;
    }
}
export interface IIsiDtoGLOB002OpenArgs extends IIsiDtoGLOBXXXOpenArgs  {
    base?: string;
}
export class IsiDtoGLOB002OpenArgs extends IsiDtoGLOBXXXOpenArgs implements IIsiDtoGLOB002OpenArgs {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGLOB002OpenArgs, Isilog.IsiComponent.IsiDataTransferObject";
    base?: string;

    constructor(data?: IIsiDtoGLOB002OpenArgs) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.base = _data["base"] !== undefined ? _data["base"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGLOB002OpenArgs): IsiDtoGLOB002OpenArgs {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGLOB002OpenArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["base"] = this.base !== undefined ? this.base : <any>null;
        return data;
    }
}
export interface IIsiDtoGLOB069OpenArgs extends IIsiDtoGLOBXXXOpenArgs  {
    enregSign?: string;
    ctrlCode?: string;
    fieldMode?: string;
    ctrlDataField?: string;
    fieldEnabled?: boolean;
    fieldLabel?: string;
}
export class IsiDtoGLOB069OpenArgs extends IsiDtoGLOBXXXOpenArgs implements IIsiDtoGLOB069OpenArgs {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGLOB069OpenArgs, Isilog.IsiComponent.IsiDataTransferObject";
    enregSign?: string;
    ctrlCode?: string;
    fieldMode?: string;
    ctrlDataField?: string;
    fieldEnabled?: boolean;
    fieldLabel?: string;

    constructor(data?: IIsiDtoGLOB069OpenArgs) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enregSign = _data["enregSign"] !== undefined ? _data["enregSign"] : <any>null;
            this.ctrlCode = _data["ctrlCode"] !== undefined ? _data["ctrlCode"] : <any>null;
            this.fieldMode = _data["fieldMode"] !== undefined ? _data["fieldMode"] : <any>null;
            this.ctrlDataField = _data["ctrlDataField"] !== undefined ? _data["ctrlDataField"] : <any>null;
            this.fieldEnabled = _data["fieldEnabled"] !== undefined ? _data["fieldEnabled"] : false;
            this.fieldLabel = _data["fieldLabel"] !== undefined ? _data["fieldLabel"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGLOB069OpenArgs): IsiDtoGLOB069OpenArgs {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGLOB069OpenArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["enregSign"] = this.enregSign !== undefined ? this.enregSign : <any>null;
        data["ctrlCode"] = this.ctrlCode !== undefined ? this.ctrlCode : <any>null;
        data["fieldMode"] = this.fieldMode !== undefined ? this.fieldMode : <any>null;
        data["ctrlDataField"] = this.ctrlDataField !== undefined ? this.ctrlDataField : <any>null;
        data["fieldEnabled"] = this.fieldEnabled !== undefined ? this.fieldEnabled : false;
        data["fieldLabel"] = this.fieldLabel !== undefined ? this.fieldLabel : <any>null;
        return data;
    }
}
export interface IIsiDtoGLOB068OpenArgs extends IIsiDtoGLOBXXXOpenArgs  {
    ctrlWidth?: number;
    isFromAdmWebPart?: boolean;
    ctrlRows?: number;
    ctrlMaxLength?: number;
    enregSign?: string;
    ctrlCode?: string;
    ctrlDataField?: string;
    ctrlClientId?: string;
    isEnabled?: boolean;
    ctrlName?: string;
}
export class IsiDtoGLOB068OpenArgs extends IsiDtoGLOBXXXOpenArgs implements IIsiDtoGLOB068OpenArgs {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGLOB068OpenArgs, Isilog.IsiComponent.IsiDataTransferObject";
    ctrlWidth?: number;
    isFromAdmWebPart?: boolean;
    ctrlRows?: number;
    ctrlMaxLength?: number;
    enregSign?: string;
    ctrlCode?: string;
    ctrlDataField?: string;
    ctrlClientId?: string;
    isEnabled?: boolean;
    ctrlName?: string;

    constructor(data?: IIsiDtoGLOB068OpenArgs) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ctrlWidth = _data["ctrlWidth"] !== undefined ? _data["ctrlWidth"] : 0;
            this.isFromAdmWebPart = _data["isFromAdmWebPart"] !== undefined ? _data["isFromAdmWebPart"] : false;
            this.ctrlRows = _data["ctrlRows"] !== undefined ? _data["ctrlRows"] : 0;
            this.ctrlMaxLength = _data["ctrlMaxLength"] !== undefined ? _data["ctrlMaxLength"] : 0;
            this.enregSign = _data["enregSign"] !== undefined ? _data["enregSign"] : <any>null;
            this.ctrlCode = _data["ctrlCode"] !== undefined ? _data["ctrlCode"] : <any>null;
            this.ctrlDataField = _data["ctrlDataField"] !== undefined ? _data["ctrlDataField"] : <any>null;
            this.ctrlClientId = _data["ctrlClientId"] !== undefined ? _data["ctrlClientId"] : <any>null;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : false;
            this.ctrlName = _data["ctrlName"] !== undefined ? _data["ctrlName"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGLOB068OpenArgs): IsiDtoGLOB068OpenArgs {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGLOB068OpenArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["ctrlWidth"] = this.ctrlWidth !== undefined ? this.ctrlWidth : 0;
        data["isFromAdmWebPart"] = this.isFromAdmWebPart !== undefined ? this.isFromAdmWebPart : false;
        data["ctrlRows"] = this.ctrlRows !== undefined ? this.ctrlRows : 0;
        data["ctrlMaxLength"] = this.ctrlMaxLength !== undefined ? this.ctrlMaxLength : 0;
        data["enregSign"] = this.enregSign !== undefined ? this.enregSign : <any>null;
        data["ctrlCode"] = this.ctrlCode !== undefined ? this.ctrlCode : <any>null;
        data["ctrlDataField"] = this.ctrlDataField !== undefined ? this.ctrlDataField : <any>null;
        data["ctrlClientId"] = this.ctrlClientId !== undefined ? this.ctrlClientId : <any>null;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : false;
        data["ctrlName"] = this.ctrlName !== undefined ? this.ctrlName : <any>null;
        return data;
    }
}
export interface IIsiDtoGLOB067OpenArgs extends IIsiDtoGLOBXXXOpenArgs  {
    codeUtil?: number;
}
export class IsiDtoGLOB067OpenArgs extends IsiDtoGLOBXXXOpenArgs implements IIsiDtoGLOB067OpenArgs {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGLOB067OpenArgs, Isilog.IsiComponent.IsiDataTransferObject";
    codeUtil?: number;

    constructor(data?: IIsiDtoGLOB067OpenArgs) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codeUtil = _data["codeUtil"] !== undefined ? _data["codeUtil"] : 0;
        }
    }

    static fromJS(data?: IIsiDtoGLOB067OpenArgs): IsiDtoGLOB067OpenArgs {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGLOB067OpenArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["codeUtil"] = this.codeUtil !== undefined ? this.codeUtil : 0;
        return data;
    }
}
export interface IIsiDtoGLOB062OpenArgs extends IIsiDtoGLOBXXXOpenArgs  {
    associatedViewId?: string;
    codeActionProcCond?: number;
    codeAction?: number;
}
export class IsiDtoGLOB062OpenArgs extends IsiDtoGLOBXXXOpenArgs implements IIsiDtoGLOB062OpenArgs {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGLOB062OpenArgs, Isilog.IsiComponent.IsiDataTransferObject";
    associatedViewId?: string;
    codeActionProcCond?: number;
    codeAction?: number;

    constructor(data?: IIsiDtoGLOB062OpenArgs) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.associatedViewId = _data["associatedViewId"] !== undefined ? _data["associatedViewId"] : <any>null;
            this.codeActionProcCond = _data["codeActionProcCond"] !== undefined ? _data["codeActionProcCond"] : 0;
            this.codeAction = _data["codeAction"] !== undefined ? _data["codeAction"] : 0;
        }
    }

    static fromJS(data?: IIsiDtoGLOB062OpenArgs): IsiDtoGLOB062OpenArgs {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGLOB062OpenArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["associatedViewId"] = this.associatedViewId !== undefined ? this.associatedViewId : <any>null;
        data["codeActionProcCond"] = this.codeActionProcCond !== undefined ? this.codeActionProcCond : 0;
        data["codeAction"] = this.codeAction !== undefined ? this.codeAction : 0;
        return data;
    }
}
export interface IIsiDtoGLOB056OpenArgs extends IIsiDtoGLOBXXXOpenArgs  {
    ligneDem?: { [key: string]: string; }[][];
}
export class IsiDtoGLOB056OpenArgs extends IsiDtoGLOBXXXOpenArgs implements IIsiDtoGLOB056OpenArgs {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGLOB056OpenArgs, Isilog.IsiComponent.IsiDataTransferObject";
    ligneDem?: { [key: string]: string; }[][];

    constructor(data?: IIsiDtoGLOB056OpenArgs) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ligneDem = _data["ligneDem"];
        }
    }

    static fromJS(data?: IIsiDtoGLOB056OpenArgs): IsiDtoGLOB056OpenArgs {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGLOB056OpenArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["ligneDem"] = this.ligneDem !== undefined ? this.ligneDem : [];
        return data;
    }
}
export interface IIsiDtoGLOB055OpenArgs extends IIsiDtoGLOBXXXOpenArgs  {
    selectedPk?: IIsiDtoSelectedRecord[];
}
export interface IIsiDtoSelectedRecord extends IIsiDataTransferObject  {
    fields?: IIsiDtoSelectedFieldValue[];
}
export interface IIsiDtoSelectedFieldValue extends IIsiDataTransferObject  {
    value?: string;
    key?: string;
}
export class IsiDtoSelectedFieldValue extends IsiDataTransferObject implements IIsiDtoSelectedFieldValue {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Mark.IsiDtoSelectedFieldValue, Isilog.IsiComponent.IsiDataTransferObject";
    value?: string;
    key?: string;

    constructor(data?: IIsiDtoSelectedFieldValue) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoSelectedFieldValue): IsiDtoSelectedFieldValue {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoSelectedFieldValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        return data;
    }
}
export class IsiDtoSelectedRecord extends IsiDataTransferObject implements IIsiDtoSelectedRecord {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Mark.IsiDtoSelectedRecord, Isilog.IsiComponent.IsiDataTransferObject";
    fields?: IsiDtoSelectedFieldValue[];

    constructor(data?: IIsiDtoSelectedRecord) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fields = _data["fields"] !== undefined ? _data["fields"] : [];
        }
    }

    static fromJS(data?: IIsiDtoSelectedRecord): IsiDtoSelectedRecord {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoSelectedRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["fields"] = this.fields !== undefined ? this.fields : [];
        return data;
    }
}
export class IsiDtoGLOB055OpenArgs extends IsiDtoGLOBXXXOpenArgs implements IIsiDtoGLOB055OpenArgs {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGLOB055OpenArgs, Isilog.IsiComponent.IsiDataTransferObject";
    selectedPk?: IsiDtoSelectedRecord[];

    constructor(data?: IIsiDtoGLOB055OpenArgs) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.selectedPk = _data["selectedPk"] !== undefined ? _data["selectedPk"] : [];
        }
    }

    static fromJS(data?: IIsiDtoGLOB055OpenArgs): IsiDtoGLOB055OpenArgs {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGLOB055OpenArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["selectedPk"] = this.selectedPk !== undefined ? this.selectedPk : [];
        return data;
    }
}
export interface IIsiDtoGLOB054OpenArgs extends IIsiDtoGLOBXXXOpenArgs  {
    objQuantite?: string;
    codeObj?: number;
    mode?: string;
    noAppel?: string;
    ligneId?: string[];
}
export class IsiDtoGLOB054OpenArgs extends IsiDtoGLOBXXXOpenArgs implements IIsiDtoGLOB054OpenArgs {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGLOB054OpenArgs, Isilog.IsiComponent.IsiDataTransferObject";
    objQuantite?: string;
    codeObj?: number;
    mode?: string;
    noAppel?: string;
    ligneId?: string[];

    constructor(data?: IIsiDtoGLOB054OpenArgs) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.objQuantite = _data["objQuantite"] !== undefined ? _data["objQuantite"] : <any>null;
            this.codeObj = _data["codeObj"] !== undefined ? _data["codeObj"] : 0;
            this.mode = _data["mode"] !== undefined ? _data["mode"] : <any>null;
            this.noAppel = _data["noAppel"] !== undefined ? _data["noAppel"] : <any>null;
            this.ligneId = _data["ligneId"] !== undefined ? _data["ligneId"] : [];
        }
    }

    static fromJS(data?: IIsiDtoGLOB054OpenArgs): IsiDtoGLOB054OpenArgs {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGLOB054OpenArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["objQuantite"] = this.objQuantite !== undefined ? this.objQuantite : <any>null;
        data["codeObj"] = this.codeObj !== undefined ? this.codeObj : 0;
        data["mode"] = this.mode !== undefined ? this.mode : <any>null;
        data["noAppel"] = this.noAppel !== undefined ? this.noAppel : <any>null;
        data["ligneId"] = this.ligneId !== undefined ? this.ligneId : [];
        return data;
    }
}
export interface IIsiDtoGLOB050OpenArgs extends IIsiDtoGLOBXXXOpenArgs  {
    lockerId?: string;
}
export class IsiDtoGLOB050OpenArgs extends IsiDtoGLOBXXXOpenArgs implements IIsiDtoGLOB050OpenArgs {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGLOB050OpenArgs, Isilog.IsiComponent.IsiDataTransferObject";
    lockerId?: string;

    constructor(data?: IIsiDtoGLOB050OpenArgs) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lockerId = _data["lockerId"] !== undefined ? _data["lockerId"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGLOB050OpenArgs): IsiDtoGLOB050OpenArgs {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGLOB050OpenArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["lockerId"] = this.lockerId !== undefined ? this.lockerId : <any>null;
        return data;
    }
}
export interface IIsiDtoGLOB029OpenArgs extends IIsiDtoGLOBXXXOpenArgs  {
    codeEcranModele?: string;
}
export class IsiDtoGLOB029OpenArgs extends IsiDtoGLOBXXXOpenArgs implements IIsiDtoGLOB029OpenArgs {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGLOB029OpenArgs, Isilog.IsiComponent.IsiDataTransferObject";
    codeEcranModele?: string;

    constructor(data?: IIsiDtoGLOB029OpenArgs) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codeEcranModele = _data["codeEcranModele"] !== undefined ? _data["codeEcranModele"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGLOB029OpenArgs): IsiDtoGLOB029OpenArgs {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGLOB029OpenArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["codeEcranModele"] = this.codeEcranModele !== undefined ? this.codeEcranModele : <any>null;
        return data;
    }
}
export interface IIsiUIFlowResult {
}
export interface IIsiDtoGLOBXXXClosingArgs extends IIsiDataTransferObject,IIsiUIFlowResult  {
    result?: boolean;
    continue?: boolean;
}
export class IsiDtoGLOBXXXClosingArgs extends IsiDataTransferObject implements IIsiDtoGLOBXXXClosingArgs {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGLOBXXXClosingArgs, Isilog.IsiComponent.IsiDataTransferObject";
    result?: boolean;
    continue?: boolean;

    constructor(data?: IIsiDtoGLOBXXXClosingArgs) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : false;
            this.continue = _data["continue"] !== undefined ? _data["continue"] : false;
        }
    }

    static fromJS(data?: IIsiDtoGLOBXXXClosingArgs): IsiDtoGLOBXXXClosingArgs {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGLOBXXXClosingArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["result"] = this.result !== undefined ? this.result : false;
        data["continue"] = this.continue !== undefined ? this.continue : false;
        return data;
    }
}
export interface IIsiDtoGLOB029ClosingArgs extends IIsiDtoGLOBXXXClosingArgs  {
    interEcranSource?: boolean;
    vueAssocSource?: boolean;
    reqVTSource?: boolean;
    actionSource?: boolean;
    designSource?: boolean;
    msgTypeSource?: boolean;
    isModelsFusion?: boolean;
    codeEcranModele?: string;
}
export class IsiDtoGLOB029ClosingArgs extends IsiDtoGLOBXXXClosingArgs implements IIsiDtoGLOB029ClosingArgs {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGLOB029ClosingArgs, Isilog.IsiComponent.IsiDataTransferObject";
    interEcranSource?: boolean;
    vueAssocSource?: boolean;
    reqVTSource?: boolean;
    actionSource?: boolean;
    designSource?: boolean;
    msgTypeSource?: boolean;
    isModelsFusion?: boolean;
    codeEcranModele?: string;

    constructor(data?: IIsiDtoGLOB029ClosingArgs) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.interEcranSource = _data["interEcranSource"] !== undefined ? _data["interEcranSource"] : false;
            this.vueAssocSource = _data["vueAssocSource"] !== undefined ? _data["vueAssocSource"] : false;
            this.reqVTSource = _data["reqVTSource"] !== undefined ? _data["reqVTSource"] : false;
            this.actionSource = _data["actionSource"] !== undefined ? _data["actionSource"] : false;
            this.designSource = _data["designSource"] !== undefined ? _data["designSource"] : false;
            this.msgTypeSource = _data["msgTypeSource"] !== undefined ? _data["msgTypeSource"] : false;
            this.isModelsFusion = _data["isModelsFusion"] !== undefined ? _data["isModelsFusion"] : false;
            this.codeEcranModele = _data["codeEcranModele"] !== undefined ? _data["codeEcranModele"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGLOB029ClosingArgs): IsiDtoGLOB029ClosingArgs {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGLOB029ClosingArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["interEcranSource"] = this.interEcranSource !== undefined ? this.interEcranSource : false;
        data["vueAssocSource"] = this.vueAssocSource !== undefined ? this.vueAssocSource : false;
        data["reqVTSource"] = this.reqVTSource !== undefined ? this.reqVTSource : false;
        data["actionSource"] = this.actionSource !== undefined ? this.actionSource : false;
        data["designSource"] = this.designSource !== undefined ? this.designSource : false;
        data["msgTypeSource"] = this.msgTypeSource !== undefined ? this.msgTypeSource : false;
        data["isModelsFusion"] = this.isModelsFusion !== undefined ? this.isModelsFusion : false;
        data["codeEcranModele"] = this.codeEcranModele !== undefined ? this.codeEcranModele : <any>null;
        return data;
    }
}
export interface IIsiDtoGlob026ClientInfo extends IIsiDataTransferObject  {
    models?: { [key: string]: IIsiDtoMergeUI; };
    recordAllowMemo?: boolean;
    displayMergedRecords?: boolean;
    mergeRecordCount?: number;
}
export interface IIsiDtoMergeUI extends IIsiDataTransferObject  {
    isModCAB?: boolean;
    type?: string;
    isLinkedToAttachement?: boolean;
    isRestricted?: boolean;
    comments?: string;
    code?: number;
}
export class IsiDtoMergeUI extends IsiDataTransferObject implements IIsiDtoMergeUI {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.Merge.IsiDtoMergeUI, Isilog.IsiComponent.IsiDataTransferObject";
    isModCAB?: boolean;
    type?: string;
    isLinkedToAttachement?: boolean;
    isRestricted?: boolean;
    comments?: string;
    code?: number;

    constructor(data?: IIsiDtoMergeUI) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isModCAB = _data["isModCAB"] !== undefined ? _data["isModCAB"] : false;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.isLinkedToAttachement = _data["isLinkedToAttachement"] !== undefined ? _data["isLinkedToAttachement"] : false;
            this.isRestricted = _data["isRestricted"] !== undefined ? _data["isRestricted"] : false;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : 0;
        }
    }

    static fromJS(data?: IIsiDtoMergeUI): IsiDtoMergeUI {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoMergeUI();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["isModCAB"] = this.isModCAB !== undefined ? this.isModCAB : false;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["isLinkedToAttachement"] = this.isLinkedToAttachement !== undefined ? this.isLinkedToAttachement : false;
        data["isRestricted"] = this.isRestricted !== undefined ? this.isRestricted : false;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        data["code"] = this.code !== undefined ? this.code : 0;
        return data;
    }
}
export class IsiDtoGlob026ClientInfo extends IsiDataTransferObject implements IIsiDtoGlob026ClientInfo {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGlob026ClientInfo, Isilog.IsiComponent.IsiDataTransferObject";
    models?: { [key: string]: IsiDtoMergeUI; };
    recordAllowMemo?: boolean;
    displayMergedRecords?: boolean;
    mergeRecordCount?: number;

    constructor(data?: IIsiDtoGlob026ClientInfo) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.models = _data["models"] !== undefined ? _data["models"] : <any>null;
            this.recordAllowMemo = _data["recordAllowMemo"] !== undefined ? _data["recordAllowMemo"] : false;
            this.displayMergedRecords = _data["displayMergedRecords"] !== undefined ? _data["displayMergedRecords"] : false;
            this.mergeRecordCount = _data["mergeRecordCount"] !== undefined ? _data["mergeRecordCount"] : 0;
        }
    }

    static fromJS(data?: IIsiDtoGlob026ClientInfo): IsiDtoGlob026ClientInfo {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGlob026ClientInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["models"] = this.models !== undefined ? this.models : <any>null;
        data["recordAllowMemo"] = this.recordAllowMemo !== undefined ? this.recordAllowMemo : false;
        data["displayMergedRecords"] = this.displayMergedRecords !== undefined ? this.displayMergedRecords : false;
        data["mergeRecordCount"] = this.mergeRecordCount !== undefined ? this.mergeRecordCount : 0;
        return data;
    }
}
export interface IIsiDtoGlobMergeOpenArgs extends IIsiDtoGLOBXXXOpenArgs  {
    requestCode?: number;
    screenHierName?: string;
    exportType?: ExportType;
    screenName?: string;
    screenType?: ScreenType;
}
export enum ExportType {
    None = 0,
    TXSL = 1,
    TEXCEL = 2,
    TTXT = 3,
    TRSS = 4,
    TPUBLIPOSTAGE = 5,
}
export enum ScreenType {
    TGRID = 0,
    TFORM = 1,
    TVT = 2,
    TFormSearch = 3,
}
export class IsiDtoGlobMergeOpenArgs extends IsiDtoGLOBXXXOpenArgs implements IIsiDtoGlobMergeOpenArgs {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGlobMergeOpenArgs, Isilog.IsiComponent.IsiDataTransferObject";
    requestCode?: number;
    screenHierName?: string;
    exportType?: ExportType;
    screenName?: string;
    screenType?: ScreenType;

    constructor(data?: IIsiDtoGlobMergeOpenArgs) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestCode = _data["requestCode"] !== undefined ? _data["requestCode"] : 0;
            this.screenHierName = _data["screenHierName"] !== undefined ? _data["screenHierName"] : <any>null;
            this.exportType = _data["exportType"] !== undefined ? _data["exportType"] : ExportType.None;
            this.screenName = _data["screenName"] !== undefined ? _data["screenName"] : <any>null;
            this.screenType = _data["screenType"] !== undefined ? _data["screenType"] : ScreenType.TGRID;
        }
    }

    static fromJS(data?: IIsiDtoGlobMergeOpenArgs): IsiDtoGlobMergeOpenArgs {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGlobMergeOpenArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["requestCode"] = this.requestCode !== undefined ? this.requestCode : 0;
        data["screenHierName"] = this.screenHierName !== undefined ? this.screenHierName : <any>null;
        data["exportType"] = this.exportType !== undefined ? this.exportType : ExportType.None;
        data["screenName"] = this.screenName !== undefined ? this.screenName : <any>null;
        data["screenType"] = this.screenType !== undefined ? this.screenType : ScreenType.TGRID;
        return data;
    }
}
export interface IIsiDtoGLOB007OpenArgs extends IIsiDtoGLOBXXXOpenArgs  {
}
export class IsiDtoGLOB007OpenArgs extends IsiDtoGLOBXXXOpenArgs implements IIsiDtoGLOB007OpenArgs {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGLOB007OpenArgs, Isilog.IsiComponent.IsiDataTransferObject";

    constructor(data?: IIsiDtoGLOB007OpenArgs) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoGLOB007OpenArgs): IsiDtoGLOB007OpenArgs {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGLOB007OpenArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
export interface IIsiDtoGLOB007ClosingArgs extends IIsiDtoGLOBXXXClosingArgs  {
    actionContextId?: string;
}
export class IsiDtoGLOB007ClosingArgs extends IsiDtoGLOBXXXClosingArgs implements IIsiDtoGLOB007ClosingArgs {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Popin.IsiDtoGLOB007ClosingArgs, Isilog.IsiComponent.IsiDataTransferObject";
    actionContextId?: string;

    constructor(data?: IIsiDtoGLOB007ClosingArgs) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.actionContextId = _data["actionContextId"] !== undefined ? _data["actionContextId"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGLOB007ClosingArgs): IsiDtoGLOB007ClosingArgs {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGLOB007ClosingArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["actionContextId"] = this.actionContextId !== undefined ? this.actionContextId : <any>null;
        return data;
    }
}
